
(function() {
	var country_cache=localStorage.getItem('country_cache');
	var cache;
	if(country_cache) {
		try {
			cache=JSON.parse(country_cache);
		}catch(e) {
		}
	}
	var now=new Date().getTime();
	var data;
  function runCache(cache) {
	data=cache.data;
	if(!data || !cache) {
		console.error('fetch failed. ipapi.co');
		return;
	}

	if(!cache.noChangeCountry) {
		var href=null;
		if(data.country_tld=='.uk') {
			href='https://lickimat.co.uk/';
		} else if(data.country_tld=='.za') {
			href='https://lickimat.co.za/';
		} else if(data.country_tld=='.us') {
			href='https://lickimat.us/';
		}
		if(href) {
			if(confirm('We have a website especially for people from '+
				data.country_name+
				"\nDo you wish to go there?")
			) {
				location.href=href;
			} else {
				cache.noChangeCountry=true;
			}
		}
	}

	localStorage.setItem('country_cache',JSON.stringify(cache));
  }
 
	if(!cache || cache.expireTime<now) {
		return fetch('https://ipapi.co/json/')
		  .then(function(response) {
		    return response.json();
		  }).then(
            (data) => {
        		if(!cache) cache={};
        		cache.data=data;
        		data.expireTime=now+(1000*60*60*31);
              runCache(cache);
            }
          );
	} else {
              runCache(cache);
    }
})();

